module.exports = __webpack_public_path__ + "static/media/markets_logo.94b9eab1.svg";